import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=56a90be6&"
import script from "./BackLink.vue?vue&type=script&lang=js&"
export * from "./BackLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports